import React from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import CalculatorPage from "./pages/CalculatorPage";
import EbooksPage from "./pages/EbooksPage";
import WhyMePage from "./pages/WhyMePage";
import ContactPage from "./pages/ContactPage";
import VideosPage from "./pages/VideosPage";
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <BrowserRouter>
      <div className="App bg-[#0a0a0a] text-[#f5f1e8] min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/o-mnie" element={<AboutPage />} />
            <Route path="/oferta" element={<ServicesPage />} />
            <Route path="/kalkulator" element={<CalculatorPage />} />
            <Route path="/ebooki" element={<EbooksPage />} />
            <Route path="/video" element={<VideosPage />} />
            <Route path="/dlaczego-ja" element={<WhyMePage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#141417",
              border: "1px solid rgba(212,169,74,0.35)",
              color: "#f5f1e8",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
